import { RootState } from 'store';
import { createSelector } from 'reselect';
import Cookies from 'universal-cookie';

export const getAllCookies = createSelector(
  ({ cookie }: RootState) => cookie,
  cookies => {
    const cookieWorker = new Cookies(cookies);
    return cookieWorker.getAll();
  }
);

export const getAllCookiesString = (state: RootState) => state.cookie;

export const getIsAuthorized = createSelector(getAllCookies, cookie => cookie?.['user-auth'] === 'true');
